//document ready
$(function () {
  /* give attribute to selector for ADA +++  validator  */
  $(".single-option-selector").attr("aria-label", "Select Variant here");

  var scrollOnClick = true;

  // Accordion product page
  $(".accordion .accordion__label").click(function () {
    var $el = $(this),
      $item = $el.closest(".accordion__item");
    $(".accordion__item").removeClass("active");
    $(".accordion__item").attr("aria-expanded", "false");
    $item.addClass("active");
    $el.attr("aria-expanded", "true");

    if (scrollOnClick) {
      var topBarsH = 0;
      if ($(".main_nav_wrapper.sticky_nav").length)
        topBarsH += $(".main_nav_wrapper.sticky_nav").outerHeight();
      if ($(".product-sticky-form.active").length)
        topBarsH += $(".product-sticky-form.active").outerHeight();

      var offset = $(window).width() > 798 && scrollOnClick ? topBarsH : 42;
      setTimeout(function () {
        goToPos($item, offset);
      }, 550);
    }
  });

  // Option select sticky form change triggers main form
  $(".product-sticky-form .single-option-selector").change(function () {
    var $el = $(this),
      dataOpt = $el.data("option"),
      val = $el.val();

    $('.product-info-container .shopify-product-form [data-option="' + dataOpt + '"]').val(val);

    //trigger Size selector product 2.0
    if ($(".product-info-container").find(".description.size").length > 0) {
      var buttons = $(".product-info-container .description.size button");
      buttons.removeClass("selected");
      buttons.filter('[data-value="' + val + '"]').addClass("selected");
    }
  });

  // Custom select for product properties (kudos to K.Statua)
  $(".product_section_container .shopify-product-form").on("mousedown", ".single-option-selector", function (event) {
    event.preventDefault();

    function animateOpenAccordion(identifier, value) {
      // animation open like accordion
      var $wrapper = $("[data-id='" + identifier + "']"),
        wrapper = $wrapper[0],
        $innerWrapper = $wrapper.find(".anim-open-accordion-wrapper"),
        heightToSet = $innerWrapper.outerHeight(true);

      $innerWrapper.find('.single-option').attr("data-sel", 0);
      $innerWrapper.find('.single-option[data-value="' + value + '"]').attr("data-sel", 1);

      wrapper.style.height = heightToSet + "px";
    }

    var $this = $(this),
      identifier = $this.attr("id"),
      dataOption = $this.data("option"),
      data = $this.find("option"),
      val = $this.val(),
      tmpl = "<span class='single-option' data-value='VALUE' data-sel='SELECTED'>TEXT</span>",
      $parent = $this.parents(".product-buy-info"),
      stringAggregator = "", // needs for collect all options
      $wrapper = $("[data-id='" + identifier + "']");

    if ($wrapper.length === 0) {
      $(data).each(function (i, el) {
        var supportString = tmpl,
          optionVal = $(el).attr("value"),
          optionTxt = $(el).text();
        supportString = supportString.replace("TEXT", optionTxt);
        supportString = supportString.replace("VALUE", optionVal);
        supportString = supportString.replace("SELECTED", optionVal == val ? "1" : "0");
        stringAggregator += supportString; // collecting options
      });

      var htmlTemplate = "<div data-id='" + identifier + "' data-option='" + dataOption + "' class='anim-open-accordion'><div class='anim-open-accordion-wrapper'>" + stringAggregator + "</div></div>"; // generating template
      $parent.after(htmlTemplate); // printing template
      $parent.addClass("with-arrow");

      animateOpenAccordion(identifier, val);
    } else {
      if ($wrapper.outerHeight(true) !== 0) {
        $wrapper.height(0);
        $parent.removeClass("with-arrow");
      } else {
        animateOpenAccordion(identifier, val);
        $parent.addClass("with-arrow");
      }
    }
  });

  $(".product_section_container").on("click", ".anim-open-accordion .single-option", function () {
    function GTM_PUSH_INFO() {
      setTimeout(function () {
        if (typeof GTM.variant_sku !== "undefined" && typeof dataLayer == "object") {
          dataLayer.push({
            event: "GAevent",
            ss_event_id: GTM.getGtmRandomString(),
            eventID: "31",
            eventCategory: "product",
            eventAction: "size",
            eventLabel: GTM.variant_name.replace(" ", "_"),
            sku: GTM.variant_sku
          });
        }
      }, 10);
    }

    GTM_PUSH_INFO();
    var thisValue = $(this).data("value"),
      $parent = $(this).parents(".anim-open-accordion"),
      targetSelect = $parent.data("id"),
      targetSelectDataOption = $parent.data("option"),
      $targetSelect = $("#" + targetSelect),
      $stickySelect = $('.product-sticky-form [data-option="' + targetSelectDataOption + '"]'),
      $targetSelectParent = $targetSelect.parents(".product-buy-info");

    $targetSelectParent.removeClass("with-arrow");
    $targetSelect.val(thisValue);
    $stickySelect.val(thisValue);
    $targetSelect.trigger("change");
    $parent.height(0);
  });

  // Size selector product 2.0
  var $sizeSelectButtons = $(".product_section_container").find(
    ".description.size .size-select .size-select-button"
  );
  $sizeSelectButtons.on("click keydown", function (event) {
    if (event.type === "click" || (event.type === "keydown" && (event.key === "Enter" || event.key === " "))) {
      event.preventDefault();
      $sizeSelectButtons.removeClass("selected");
      $sizeSelectButtons.attr("aria-checked", 'false');
      $(this).addClass("selected");
      $(this).attr("aria-checked", 'true');
      $(".product_section_container .shopify-product-form .single-option-selector").trigger("mousedown");
      var selectedValue = $(this).data("value");
      var $options = $(".product_section_container").find(".single-option");

      $options.each(function () {
        if ($(this).data("value") === selectedValue) {
          $(this).trigger("click");
        }
      });

      var selectedVariantId = $(this).data("variant-id");
      const $tabToShow = $("#variant-" + selectedVariantId);
      const $iconToShow = $(".flex-items-variant-net-zero#icon-variant-" + selectedVariantId);
      const $tabWrapper = $tabToShow.parents(".double-accordion__item");
      $(".variant-specifics").hide();
      $(".flex-items-variant-net-zero").hide();
      $tabToShow.show();
      $iconToShow.show();
      $tabWrapper.toggle($tabToShow.data("empty") != 0);
      $iconToShow.toggle($iconToShow.data("empty") != 0);
    }
  });

  $(document).ready(function () {
    var selectedButton = $sizeSelectButtons.filter(".selected");
    var initialVariantId;

    if (selectedButton.length) {
      initialVariantId = selectedButton.data("variant-id");
    }

    // If no variant is selected, get the first available variant
    if (!initialVariantId) {
      var $firstVariant = $(".variant-specifics").first();
      if ($firstVariant.length) {
        initialVariantId = $firstVariant.attr("id").replace("variant-", "");
      }
    }

    if (initialVariantId) {
      const $tabToShow = $("#variant-" + initialVariantId);
      const $iconToShow = $(".flex-items-variant-net-zero#icon-variant-" + initialVariantId);
      const $tabWrapper = $tabToShow.parents(".double-accordion__item");
      $tabToShow.show();
      $iconToShow.show();
      $tabWrapper.toggle($tabToShow.data("empty") != 0);
      $iconToShow.toggle($iconToShow.data("empty") != 0);
    }
  });

  // Quantity selector product 2.0
  $("input.new-product-quantity").on("change", function () {
    var inputValue = $(this).val();
    if (inputValue > 10) inputValue = 10;
    $("#new-product-quantity").val(inputValue);
  });

  $("#new-product-quantity").change(function () {
    $(".shopify-product-form")
      .find('input[name="quantity"]')
      .val($(this).val());
  });

  // Manual refresh for product gallery.
  // Unfortunately the js navigation script doesn't have a callback for page load...
  function checkProductGallery() {
    var myInt = setInterval(function () {
      var $flickityWrapper = $(".flickity-viewport");
      var $flickityItems = $(".flickity-slider").children();
      var height = $flickityWrapper.outerHeight(true);

      if ($flickityItems.length == 0) {
        clearInterval(myInt);
      } else if (height == 0 || typeof height === "undefined") {
        $(".js-product-gallery").flickity("resize");
      } else {
        clearInterval(myInt);
      }
    }, 1000);
  }
  checkProductGallery();

  function socialBtn() {
    var $btn = $(".social_buttons-toggler"),
      $btns = $(".social_buttons");

    $btns.slideUp(0);
    $btn.click(function () {
      $btns.slideToggle(250);
    });
  }

  socialBtn();

  $(".flickity-prev-next-button").click(function () {
    if (typeof dataLayer == "object") {
      dataLayer.push({
        event: "GAevent",
        ss_event_id: GTM.getGtmRandomString(),
        eventID: "33",
        eventCategory: "product",
        eventAction: "image",
        eventLabel: GTM.image_progression,
        sku: GTM.variant_sku
      });
    }
  });

  //Sustainability desc product 2.0
  $(document).ready(function () {
    var $sustainabilityText = $(".product-qualities.product-sustainability .quality .sustainability-text");
    function removeActiveClasses() {
      $sustainabilityText.removeClass("active-text");
      $(".sustainability-desc").removeClass("active-desc");
    }

    $sustainabilityText.click(function (event) {
      event.stopPropagation();
      var $this = $(this);
      var $desc = $this.next(".sustainability-desc");

      if ($this.hasClass("active-text") || $desc.hasClass("active-desc")) {
        removeActiveClasses();
      } else {
        removeActiveClasses();
        if (window.matchMedia("(max-width: 768px)").matches) {
          $this.addClass("active-text");
          $desc.addClass("active-desc");
        }
      }
    });

    $(document).click(function () {
      removeActiveClasses();
    });

    $(window).resize(function () {
      removeActiveClasses();
    });
  });

  customGiftCard.init();
});

var customGiftCard = {
  init: function () {
    this.variantBtn();
  },
  variantBtn: function () {
    $(".gift-card__select").click(function (e) {
      e.preventDefault();
      var varID = this.getAttribute("data-id");
      var varName = this.getAttribute("data-name");
      $('select[name="id"]').val(varID).trigger("change");
      $(".single-option-selector").val(varName).trigger("change");
      $(".gift-card__select").removeClass("selected");
      $(this).addClass("selected");
    });
  }
};
